import { render, staticRenderFns } from "./shopBanner.vue?vue&type=template&id=a689096c&scoped=true"
import script from "./shopBanner.vue?vue&type=script&lang=js"
export * from "./shopBanner.vue?vue&type=script&lang=js"
import style0 from "./shopBanner.vue?vue&type=style&index=0&id=a689096c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a689096c",
  null
  
)

component.options.__file = "shopBanner.vue"
export default component.exports